import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-container" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "•••", -1)
const _hoisted_5 = { class: "tf" }
const _hoisted_6 = { class: "current" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Completed", -1)
const _hoisted_8 = { class: "previous" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "completed" }, "Completed", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.timeframes, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["icon", _ctx.getWrapperClass(item.title)]),
        key: index
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("p", _hoisted_3, [
              _createElementVNode("span", null, _toDisplayString(item.title), 1),
              _hoisted_4
            ]),
            _createElementVNode("p", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, [
                _createElementVNode("span", null, _toDisplayString(item.timeframes[_ctx.timeframe].current), 1),
                _hoisted_7
              ]),
              _createElementVNode("span", _hoisted_8, [
                _createTextVNode("Last week: " + _toDisplayString(item.timeframes[_ctx.timeframe].previous) + " ", 1),
                _hoisted_9
              ])
            ])
          ])
        ])
      ], 2))
    }), 128))
  ]))
}